function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import i18n from 'invision-core/src/components/i18n/i18n';
import { PageSizePreferenceSelector } from 'invision-core/src/components/session/session.selectors';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import { formHasErrors } from 'invision-core/src/components/helpers/form.helper';
import { fetchCodeTypes, fetchCreditCardTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { ExternalReferenceOptionsForCoreValuesSelector, MetadataCodeLoadedSelector, MetadataCodeTypeSelector, MetadataOptionsForCodeValuesWithoutPlaceholderSelector, SubscriberCategoryRequirementsForCurrentBusinessUnitOrDefault, SubscriberRequirementsForCurrentBusinessUnitOrDefault } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { EMAIL_ADDRESSES, NUMBERS_ONLY_OR_BLANK } from 'invision-core/src/constants/validation.constants';
import { AdditionalPropertyValueType } from 'invision-core/src/components/metadata/codes/codes.additional.properties.constants';
import CustomerCareLocaleKeys from '../../../locales/keys';
import { REGEXES } from '../../../customercare.constants';
import { FILTER_PAYMENT_INSTRUMENT_TYPE, getSearchFieldsTemplate, SEARCH_DROPDOWN_CONSTANTS, SEARCH_PAYMENT_INSTRUMENT_TYPES } from '../search.constants';
import { getCustomerSearch, searchSubscriberSuggestions } from '../../../reducers/actions/search.customer.actions';
import { getCouponSearch } from '../../../reducers/actions/search.coupon.actions';
import { getGiftCardSearch } from '../../../reducers/actions/search.giftcard.actions';
import { clearSearchError, setSearchType } from '../../../reducers/actions/search.actions';
import { CaseSearchFieldsEnabledSelector, CustomerSearchRecordCountSelector, CustomerSearchSuggestionsIsLoadingSelector, CustomerSearchSuggestionsSelector } from '../../../reducers/selectors/search.customer.selectors';
import { IsPredictiveSearchEnabledSelector, SearchApiErrorSelector, SearchIsFetchingResultsSelector, SearchTypeSelector, SearchOptionsSelector } from '../../../reducers/selectors/search.selectors';
import { setEditApOnChange } from '../../../reducers/actions/customer.actions';
import { GiftCardSearchRecordCountSelector } from '../../../reducers/selectors/search.giftcard.selectors';
import { CouponSearchRecordCountSelector } from '../../../reducers/selectors/search.coupon.selectors';
import { IsPIIDataAccessEnabledSelector, SelectedCustomerCategorySelector } from '../../../reducers/selectors/customer.selectors';
import { CUSTOMER_CATEGORY } from '../../createCustomerPopup/create.customer.popup.constants';
import { SubscriberIdentificationsSelector } from '../../createCustomerPopup/customer.form.dropdown.selectors';
import { SubscriberAdditionalPropertiesSelector } from '../../createCustomer/additionalPropertiesSection/additional.properties.filtered.selector';
export function SearchFieldsController($ngRedux, $element, $timeout) {
  var _this = this;
  var disconnectRedux;
  var mapStateToTarget = function mapStateToTarget(store) {
    return {
      apiErrors: SearchApiErrorSelector(store),
      caseExternalReferenceTypes: ExternalReferenceOptionsForCoreValuesSelector(CODES.CaseExternalReferenceType, store),
      caseExternalReferenceTypesLoaded: MetadataCodeLoadedSelector(CODES.CaseExternalReferenceType, store),
      caseSearchFieldsEnabled: CaseSearchFieldsEnabledSelector(store),
      couponSearchResultCount: CouponSearchRecordCountSelector(store),
      creditCardTypes: MetadataCodeTypeSelector(CODES.CreditCardType, store),
      customerCategory: SelectedCustomerCategorySelector(store),
      customerSearchResultCount: CustomerSearchRecordCountSelector(store),
      customerSearchSuggestions: CustomerSearchSuggestionsSelector(store),
      customerSearchSuggestionsIsLoading: CustomerSearchSuggestionsIsLoadingSelector(store),
      externalBillTypes: MetadataCodeTypeSelector(CODES.ExternalBillType, store),
      externalBillTypesLoaded: MetadataCodeLoadedSelector(CODES.ExternalBillType, store),
      featureTogglesLoaded: MetadataCodeLoadedSelector(CODES.FeatureToggleConfig, store),
      giftCardSearchResultCount: GiftCardSearchRecordCountSelector(store),
      isDbss: IsDbss(store),
      isFetchingResults: SearchIsFetchingResultsSelector(store),
      isPredictiveSearchEnabled: IsPredictiveSearchEnabledSelector(store),
      isPIIDataAccessEnabled: IsPIIDataAccessEnabledSelector(store),
      isTemplateLoaded: MetadataCodeLoadedSelector(CODES.BusinessUnitTemplate, store),
      pageSize: PageSizePreferenceSelector(store),
      paymentInstrumentTypes: MetadataCodeTypeSelector(CODES.PaymentInstrumentType, store),
      paymentInstrumentTypesLoaded: MetadataCodeLoadedSelector(CODES.PaymentInstrumentType, store),
      personTitleOptions: MetadataOptionsForCodeValuesWithoutPlaceholderSelector(CODES.PersonTitle, store),
      searchOptions: SearchOptionsSelector(store),
      searchType: SearchTypeSelector(store),
      subscriberCategoryRequirements: SubscriberCategoryRequirementsForCurrentBusinessUnitOrDefault(store),
      subscriberIdentifications: SubscriberIdentificationsSelector(store),
      subscriberIdentificationsLoaded: MetadataCodeLoadedSelector(CODES.SubscriberIdentifications, store),
      subscriberRequirements: SubscriberRequirementsForCurrentBusinessUnitOrDefault(store),
      subscriberSearchConfigLoaded: MetadataCodeLoadedSelector(CODES.SubscriberSearchConfig, store),
      subscriberAdditionalPropData: SubscriberAdditionalPropertiesSelector(store)
    };
  };
  this.$onInit = function () {
    Object.assign(_this, {
      $timeout: $timeout,
      accountNumberRegEx: REGEXES.NUMBERS_ONLY_OR_BLANK,
      canShowNoResultsError: false,
      caseExternalReferenceDocuments: [],
      coreLocaleKeys: CoreLocaleKeys,
      customerCareLocaleKeys: CustomerCareLocaleKeys,
      customerFormSearchModel: angular.copy(_this.customerSearchModel),
      EMAIL_ADDRESSES: EMAIL_ADDRESSES,
      emailRegEx: REGEXES.EMAIL,
      identificationDocuments: [],
      NUMBERS_ONLY_OR_BLANK: NUMBERS_ONLY_OR_BLANK,
      onAdditionalPropertyChange: _this.onAdditionalPropertyChange.bind(_this),
      orderIdRegEx: REGEXES.NUMBERS_ONLY_OR_BLANK,
      purchaseReceiptReferenceLabel: '',
      SEARCH_PAYMENT_INSTRUMENT_TYPES: SEARCH_PAYMENT_INSTRUMENT_TYPES,
      searchDropdownConstants: SEARCH_DROPDOWN_CONSTANTS,
      singeSelectDropDownWidth: '43%',
      subscriberIdRegEx: REGEXES.NUMBERS_ONLY_OR_BLANK
    });
    _this.clearAllErrors();
    var controllerActions = {
      clearSearchError: clearSearchError,
      fetchCodeTypes: fetchCodeTypes,
      fetchCreditCardTypes: fetchCreditCardTypes,
      getCouponSearch: getCouponSearch,
      getCustomerSearch: getCustomerSearch,
      getGiftCardSearch: getGiftCardSearch,
      searchSubscriberSuggestions: searchSubscriberSuggestions,
      setEditApOnChange: setEditApOnChange,
      setSearchType: setSearchType
    };
    disconnectRedux = $ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
      _this.state = state;
      _this.actions = actions;
    });

    // Expose inner function to the parent
    if (_this.searchFieldsApi) {
      _this.searchFieldsApi()({
        clearSearch: function clearSearch() {
          _this.clearSearch();
        }
      });
    }
    if (!_this.state.externalBillTypesLoaded) {
      _this.actions.fetchCodeTypes(CODES.ExternalBillType);
    }
    if (!_this.state.paymentInstrumentTypesLoaded) {
      _this.actions.fetchCodeTypes(CODES.PaymentInstrumentType);
    }
    if (!_this.state.subscriberSearchConfigLoaded) {
      _this.actions.fetchCodeTypes(CODES.SubscriberSearchConfig);
    }
    if (!_this.state.isTemplateLoaded) {
      _this.actions.fetchCodeTypes(CODES.BusinessUnitTemplate);
    }
    if (_this.state.creditCardTypes.length === 0) {
      _this.actions.fetchCreditCardTypes();
    }
    if (!_this.state.subscriberIdentificationsLoaded) {
      _this.actions.fetchCodeTypes(CODES.SubscriberIdentifications).then(function () {
        _this.formatSubscriberIdentificationType();
      });
    } else {
      _this.formatSubscriberIdentificationType();
    }
    if (!_this.state.caseExternalReferenceTypesLoaded) {
      _this.actions.fetchCodeTypes(CODES.CaseExternalReferenceType).then(function () {
        _this.formatCaseExternalReferenceType();
      });
    } else {
      _this.formatCaseExternalReferenceType();
    }
    if (!_this.state.featureTogglesLoaded) {
      _this.actions.fetchCodeTypes(CODES.FeatureToggleConfig);
    }
    _this.errorLookup = _this.getErrorLookupObject();
    _this.selectedIdentificationEntity = _this.customerFormSearchModel.subscriberIdentification ? _this.customerFormSearchModel.subscriberIdentification.Value : null;
    if (_this.customerFormSearchModel.subscriberIdentification && _this.customerFormSearchModel.subscriberIdentification.Type) {
      _this.identificationDocuments = _this.identificationDocuments.map(function (identityDocument) {
        if (identityDocument.id === _this.customerFormSearchModel.subscriberIdentification.Type) {
          identityDocument.selected = true;
        } else {
          identityDocument.selected = false;
        }
        return identityDocument;
      });
    }
    _this.selectedCaseExternalReferenceEntity = _this.customerFormSearchModel.caseExternalReference ? _this.customerFormSearchModel.caseExternalReference.Value : null;
    if (_this.customerFormSearchModel.caseExternalReference && _this.customerFormSearchModel.caseExternalReference.Type) {
      _this.caseExternalReferenceDocuments = _this.caseExternalReferenceDocuments.map(function (caseExternalRefDoc) {
        if (caseExternalRefDoc.id === _this.customerFormSearchModel.caseExternalReference.Type) {
          caseExternalRefDoc.selected = true;
        } else {
          caseExternalRefDoc.selected = false;
        }
        return caseExternalRefDoc;
      });
    }
    _this.clearCreditCardNumberPartial();
    _this.clearAllErrors = _this.clearAllErrors.bind(_this);
  };
  this.formatSubscriberIdentificationType = function () {
    _this.identificationDocuments = [{
      id: null,
      text: i18n.translate(CustomerCareLocaleKeys.SEARCH_FIELDS_CUSTOMER.SINGLE_SELECT_PLACEHOLDER),
      selected: true
    }], _this.state.subscriberIdentifications.forEach(function (indetificationDocument) {
      _this.identificationDocuments.push({
        id: indetificationDocument.Value,
        text: indetificationDocument.Name
      });
    });
  };
  this.formatCaseExternalReferenceType = function () {
    var caseExternalReferenceTypes = [];
    if (_this.state.caseExternalReferenceTypes && _this.state.caseExternalReferenceTypes.length > 0) {
      _this.state.caseExternalReferenceTypes.forEach(function (caseExtRefType) {
        caseExternalReferenceTypes.push({
          id: caseExtRefType.value,
          text: caseExtRefType.label
        });
      });
      _this.caseExternalReferenceDocuments = caseExternalReferenceTypes;
    }
  };
  this.isClearButtonShown = function () {
    return (Object.entries(_this.customerFormSearchModel) || []).some(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      if (key === FILTER_PAYMENT_INSTRUMENT_TYPE && _this.state.searchType === SEARCH_DROPDOWN_CONSTANTS.TRANSACTION || _this.state.searchType === SEARCH_DROPDOWN_CONSTANTS.ADDITIONAL_PROPERTIES && !_this.customerFormSearchModel.subscriberAdditionalProperties.length) {
        return false;
      }
      return !!value;
    }) || _this.shouldShowNoResultsError() || _this.shouldShowSearchError();
  };
  this.isSearchCleared = false;
  this.clearSearch = function () {
    _this.selectedIdentificationEntity = null;
    _this.selectedCaseExternalReferenceEntity = null;
    _this.isSearchCleared = true;
    _this.$timeout(function () {
      var filterPaymentInstrumentType = _this.customerFormSearchModel.filterPaymentInstrumentType;
      _this.customerFormSearchModel = {};
      if (filterPaymentInstrumentType !== undefined && _this.state.searchType === SEARCH_DROPDOWN_CONSTANTS.TRANSACTION) {
        _this.customerFormSearchModel.filterPaymentInstrumentType = filterPaymentInstrumentType;
      }
      if (_this.state.searchType === SEARCH_DROPDOWN_CONSTANTS.ADDITIONAL_PROPERTIES) {
        _this.customerFormSearchModel = getSearchFieldsTemplate();
      }
      _this.isSearchCleared = false;
    });
    _this.clearAllErrors();
    _this.canShowNoResultsError = false;
    _this.searchExecuted = false;
    _this.customerSearchForm.$setUntouched();
    _this.customerSearchForm.$setPristine();
    _this.formatSubscriberIdentificationType();
    _this.formatCaseExternalReferenceType();
  };
  this.emailAsLogin = function () {
    var requirements = _this.state.customerCategory === CUSTOMER_CATEGORY.COMMERCIAL ? _this.state.subscriberCategoryRequirements : _this.state.subscriberRequirements;
    return requirements.capture_email_as_login;
  };
  this.clearCreditCardNumberPartial = function () {
    _this.paymentCreditCardNumberPartial = 'false';
    _this.customerFormSearchModel.paymentFirstFourDigits = undefined;
    _this.customerFormSearchModel.paymentLastFourDigits = undefined;
  };
  this.clearCreditCardNumberFull = function () {
    _this.customerFormSearchModel.paymentAccount = undefined;
  };
  this.switchCreditCardAccountFormat = function () {
    if (_this.paymentCreditCardNumberPartial === 'true') {
      _this.clearCreditCardNumberFull();
    } else {
      _this.clearCreditCardNumberPartial();
    }
  };
  this.isPaymentInstrumentTypeRequired = function () {
    return _this.customerFormSearchModel.paymentAccount !== undefined && _this.customerFormSearchModel.paymentAccount.length > 0;
  };
  this.initiateSearch = function () {
    _this.errorLookup = _this.getErrorLookupObject();
    if (!_this.checkForErrors(_this.customerSearchForm.$error)) {
      // when they search reset the page number to 1 in case the page number was set from a previous search result
      _this.onPageChange()(1);
      _this.customerFormSearchModel.returnUniqueSubscribersByTransaction = _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.TRANSACTION, true);
      _this.onCustomerSearchModelChange()(_this.customerFormSearchModel);
      _this.canShowNoResultsError = true;

      // In the customerFormSearchModel below, if the property is falsey (such as an empty string), we want to set
      // it to undefined, so it does not send a value to the api. Also force undefined if that category belongs to
      // a different search type.
      _this.customerFormSearchModel = {
        // Address specific search-related fields
        addressLineOne: _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.ADDRESS, _this.customerFormSearchModel.addressLineOne),
        postalCode: _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.ADDRESS, _this.customerFormSearchModel.postalCode),
        // Business specific search-related fields
        deviceId: _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.ORDERSORBILLING, _this.customerFormSearchModel.deviceId),
        deviceSerialNumber: _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.ORDERSORBILLING, _this.customerFormSearchModel.deviceSerialNumber),
        orderId: _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.ORDERSORBILLING, _this.customerFormSearchModel.orderId),
        orderNumber: _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.ORDERSORBILLING, _this.customerFormSearchModel.orderNumber),
        invoiceNumber: _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.ORDERSORBILLING, _this.customerFormSearchModel.invoiceNumber),
        // Case specific search-related fields (Individual and Company)
        caseNumber: _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.INDIVIDUAL, _this.customerFormSearchModel.caseNumber) || _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.COMPANY, _this.customerFormSearchModel.caseNumber),
        caseId: _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.INDIVIDUAL, _this.customerFormSearchModel.caseId) || _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.COMPANY, _this.customerFormSearchModel.caseId),
        caseExternalReference: _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.INDIVIDUAL, _this.customerFormSearchModel.caseExternalReference) || _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.COMPANY, _this.customerFormSearchModel.caseExternalReference),
        caseIdentifier: _this.getCaseIdentifier(),
        // Company specific search-related fields
        companyName: _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.COMPANY, _this.customerFormSearchModel.companyName),
        hierarchyName: _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.COMPANY, _this.customerFormSearchModel.hierarchyName),
        // Coupon search related fields
        redemptionCode: _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.COUPON, _this.customerFormSearchModel.redemptionCode),
        // Gift Card search related fields
        accountNumber: _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.GIFT_CARD, _this.customerFormSearchModel.accountNumber),
        pin: _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.GIFT_CARD, _this.customerFormSearchModel.pin),
        senderEmail: _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.GIFT_CARD, _this.customerFormSearchModel.senderEmail),
        // Individual specific search-realated fields
        firstName: _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.INDIVIDUAL, _this.customerFormSearchModel.firstName),
        lastName: _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.INDIVIDUAL, _this.customerFormSearchModel.lastName),
        // Individual or Company specific search-related fields
        emailAddress: _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.INDIVIDUAL, _this.customerFormSearchModel.emailAddress) || _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.COMPANY, _this.customerFormSearchModel.emailAddress),
        externalId: _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.INDIVIDUAL, _this.customerFormSearchModel.externalId) || _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.COMPANY, _this.customerFormSearchModel.externalId),
        loginOrEmailAddress: _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.INDIVIDUAL, _this.customerFormSearchModel.emailAddress) || _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.COMPANY, _this.customerFormSearchModel.emailAddress),
        phoneNumber: _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.INDIVIDUAL, _this.customerFormSearchModel.phoneNumber) || _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.COMPANY, _this.customerFormSearchModel.phoneNumber),
        serviceId: _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.INDIVIDUAL, _this.customerFormSearchModel.serviceId) || _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.COMPANY, _this.customerFormSearchModel.serviceId),
        subscriberId: _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.INDIVIDUAL, _this.customerFormSearchModel.subscriberId ? parseInt(_this.customerFormSearchModel.subscriberId, 10) : undefined) || _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.COMPANY, _this.customerFormSearchModel.subscriberId ? parseInt(_this.customerFormSearchModel.subscriberId, 10) : undefined),
        emailOrLoginSuggestions: _this.customerFormSearchModel.emailOrLoginSuggestions,
        armAccountNumber: _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.INDIVIDUAL, _this.customerFormSearchModel.armAccountNumber) || _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.COMPANY, _this.customerFormSearchModel.armAccountNumber),
        subscriberIdentification: _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.INDIVIDUAL, _this.checkIfSubscriberIdentificationPresent() ? _this.customerFormSearchModel.subscriberIdentification : undefined) || _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.COMPANY, _this.checkIfSubscriberIdentificationPresent() ? _this.customerFormSearchModel.subscriberIdentification : undefined),
        title: _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.INDIVIDUAL, _this.customerFormSearchModel.title),
        // Transaction search-related fields
        filterPaymentInstrumentType: _this.isSearchCreditCard() ? SEARCH_PAYMENT_INSTRUMENT_TYPES.CREDIT_CARD : _this.customerFormSearchModel.filterPaymentInstrumentType || undefined,
        paymentAccount: _this.setPaymentAccountValue(_this.customerFormSearchModel.paymentAccount),
        paymentFirstFourDigits: _this.setPartialCreditCardValue(_this.customerFormSearchModel.paymentFirstFourDigits),
        paymentInstrumentSubType: _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.TRANSACTION, _this.customerFormSearchModel.paymentInstrumentSubTypeCreditCard || _this.customerFormSearchModel.paymentInstrumentSubTypeExternalBiller),
        paymentInstrumentSubTypeCreditCard: _this.isSearchCreditCard() ? _this.customerFormSearchModel.paymentInstrumentSubTypeCreditCard || undefined : undefined,
        paymentInstrumentSubTypeExternalBiller: _this.isSearchExternalBiller() ? _this.customerFormSearchModel.paymentInstrumentSubTypeExternalBiller || undefined : undefined,
        paymentLastFourDigits: _this.setPartialCreditCardValue(_this.customerFormSearchModel.paymentLastFourDigits),
        paymentReconciliationId: _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.TRANSACTION, _this.customerFormSearchModel.paymentReconciliationId),
        paymentReferenceId: _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.TRANSACTION, _this.customerFormSearchModel.paymentReferenceId),
        purchaseReceiptReference: _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.TRANSACTION, _this.customerFormSearchModel.purchaseReceiptReference),
        paymentTransactionDate: _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.TRANSACTION, _this.customerFormSearchModel.paymentTransactionDate),
        returnUniqueSubscribersByTransaction: _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.TRANSACTION, _this.customerFormSearchModel.returnUniqueSubscribersByTransaction),
        subscriberAdditionalProperties: _this.setProperty(SEARCH_DROPDOWN_CONSTANTS.ADDITIONAL_PROPERTIES, _this.customerFormSearchModel.subscriberAdditionalProperties)
      };
      if (_this.state.searchType === SEARCH_DROPDOWN_CONSTANTS.GIFT_CARD) {
        _this.actions.getGiftCardSearch(_this.customerFormSearchModel, 1, _this.state.pageSize);
      } else if (_this.state.searchType === SEARCH_DROPDOWN_CONSTANTS.COUPON) {
        _this.actions.getCouponSearch(_this.customerFormSearchModel, 1, _this.state.pageSize);
      } else {
        _this.actions.getCustomerSearch(_this.customerFormSearchModel, 1, _this.state.pageSize);
      }
      _this.customerSearchForm.$setUntouched();
      _this.customerSearchForm.$setPristine();
      _this.searchExecuted = true;
    }
  };
  this.setProperty = function (searchType, property) {
    return _this.state.searchType === searchType ? property || undefined : undefined;
  };
  this.getCaseIdentifier = function () {
    // Available for Individual and Company search types
    if (_this.state.searchType !== SEARCH_DROPDOWN_CONSTANTS.INDIVIDUAL && _this.state.searchType !== SEARCH_DROPDOWN_CONSTANTS.COMPANY) {
      return undefined;
    }

    // Check if case ID is provided (numeric only)
    if (_this.customerFormSearchModel.caseId) {
      return {
        Value: _this.customerFormSearchModel.caseId
      };
    }

    // Check if case external reference is provided with both Type and Value
    if (_this.checkIfCaseExternalReferencePresent()) {
      return {
        Type: _this.customerFormSearchModel.caseExternalReference.Type,
        Value: _this.customerFormSearchModel.caseExternalReference.Value
      };
    }
    return undefined;
  };
  this.setPaymentAccountValue = function (value) {
    return _this.isSearchCreditCard() && _this.paymentCreditCardNumberPartial === 'true' ? undefined : value || undefined;
  };
  this.setPartialCreditCardValue = function (partialValue) {
    return _this.paymentCreditCardNumberPartial === 'true' && _this.isSearchCreditCard() ? partialValue || undefined : undefined;
  };
  this.onOptionSelect = function (item) {
    if (_this.state.searchType !== item.id) {
      _this.setSelectedOption(item.id);
      _this.actions.setSearchType(item.id);
      _this.customerFormSearchModel = getSearchFieldsTemplate();
      _this.customerSearchForm.$setDirty();
      _this.customerSearchForm.$setUntouched();
      _this.searchExecuted = false;
      _this.clearAllErrors();
      _this.formatSubscriberIdentificationType();
      _this.formatCaseExternalReferenceType();
      _this.selectedIdentificationEntity = null;
      _this.selectedCaseExternalReferenceEntity = null;
      if (!_this.customerFormSearchModel.filterPaymentInstrumentType && item.id === SEARCH_DROPDOWN_CONSTANTS.TRANSACTION) {
        _this.customerFormSearchModel.filterPaymentInstrumentType = SEARCH_PAYMENT_INSTRUMENT_TYPES.CREDIT_CARD;
      }
    }
  };
  this.setSelectedOption = function (itemId) {
    _this.actions.setSearchType(itemId);
  };
  this.getAccountNumberFieldTitle = function () {
    var accountNumberTitle;
    switch (_this.customerFormSearchModel.filterPaymentInstrumentType) {
      case SEARCH_PAYMENT_INSTRUMENT_TYPES.CREDIT_CARD:
        accountNumberTitle = i18n.translate(_this.customerCareLocaleKeys.SEARCH_FIELDS_CUSTOMER.PAYMENT_ACCOUNT_TITLE.CREDIT_CARD);
        break;
      case SEARCH_PAYMENT_INSTRUMENT_TYPES.ECHECK:
        accountNumberTitle = i18n.translate(_this.customerCareLocaleKeys.SEARCH_FIELDS_CUSTOMER.PAYMENT_ACCOUNT_TITLE.ECHECK);
        break;
      case SEARCH_PAYMENT_INSTRUMENT_TYPES.EXTERNAL_BILLER:
        _this.purchaseReceiptReferenceLabel = i18n.translate(_this.customerCareLocaleKeys.SEARCH_FIELDS_CUSTOMER.EXTERNAL_REFERENCE_ID);
        accountNumberTitle = i18n.translate(_this.customerCareLocaleKeys.SEARCH_FIELDS_CUSTOMER.PAYMENT_ACCOUNT_TITLE.EXTERNAL_BILLING);
        break;
      case SEARCH_PAYMENT_INSTRUMENT_TYPES.ITUNES:
        _this.purchaseReceiptReferenceLabel = i18n.translate(_this.customerCareLocaleKeys.SEARCH_FIELDS_CUSTOMER.ORIGINAL_TRANSACTION_ID);
        accountNumberTitle = i18n.translate(_this.customerCareLocaleKeys.SEARCH_FIELDS_CUSTOMER.PAYMENT_ACCOUNT_TITLE.ITUNES);
        break;
      case SEARCH_PAYMENT_INSTRUMENT_TYPES.GOOGLE_PLAY:
        _this.purchaseReceiptReferenceLabel = i18n.translate(_this.customerCareLocaleKeys.SEARCH_FIELDS_CUSTOMER.PURCHASE_TOKEN);
        accountNumberTitle = i18n.translate(_this.customerCareLocaleKeys.SEARCH_FIELDS_CUSTOMER.PAYMENT_ACCOUNT_TITLE.GOOGLE_PLAY);
        break;
      case SEARCH_PAYMENT_INSTRUMENT_TYPES.PAYPAL:
        accountNumberTitle = i18n.translate(_this.customerCareLocaleKeys.SEARCH_FIELDS_CUSTOMER.PAYMENT_ACCOUNT_TITLE.PAYPAL);
        break;
      case SEARCH_PAYMENT_INSTRUMENT_TYPES.POINT_FOR_SALE:
        _this.purchaseReceiptReferenceLabel = i18n.translate(_this.customerCareLocaleKeys.SEARCH_FIELDS_CUSTOMER.RECEIPT_NUMBER);
        accountNumberTitle = i18n.translate(_this.customerCareLocaleKeys.SEARCH_FIELDS_CUSTOMER.PAYMENT_ACCOUNT_TITLE.DEFAULT);
        break;
      case SEARCH_PAYMENT_INSTRUMENT_TYPES.UWP:
        accountNumberTitle = i18n.translate(_this.customerCareLocaleKeys.SEARCH_FIELDS_CUSTOMER.PAYMENT_ACCOUNT_TITLE.UWP);
        break;
      default:
        accountNumberTitle = i18n.translate(_this.customerCareLocaleKeys.SEARCH_FIELDS_CUSTOMER.PAYMENT_ACCOUNT_TITLE.DEFAULT);
    }
    return accountNumberTitle;
  };
  this.onChangePaymentType = function () {
    _this.purchaseReceiptReferenceLabel = '';
    _this.customerFormSearchModel.purchaseReceiptReference = '';
    _this.customerFormSearchModel.paymentAccount = undefined;
    _this.customerFormSearchModel.paymentInstrumentSubTypeCreditCard = undefined;
    _this.customerFormSearchModel.paymentInstrumentSubTypeExternalBiller = undefined;
    _this.clearCreditCardNumberPartial();
    _this.getAccountNumberFieldTitle();
  };
  this.isSearchCreditCard = function () {
    return _this.customerFormSearchModel.filterPaymentInstrumentType === SEARCH_PAYMENT_INSTRUMENT_TYPES.CREDIT_CARD;
  };
  this.isSearchExternalBiller = function () {
    return _this.customerFormSearchModel.filterPaymentInstrumentType === SEARCH_PAYMENT_INSTRUMENT_TYPES.EXTERNAL_BILLER;
  };
  this.isPartialCreditCardVisible = function () {
    return _this.customerFormSearchModel.filterPaymentInstrumentType === SEARCH_PAYMENT_INSTRUMENT_TYPES.CREDIT_CARD && _this.paymentCreditCardNumberPartial === 'true';
  };
  this.isPointForSaleVisible = function () {
    return _this.customerFormSearchModel.filterPaymentInstrumentType === SEARCH_PAYMENT_INSTRUMENT_TYPES.POINT_FOR_SALE && !_this.isSearchCreditCard();
  };
  this.$onDestroy = function () {
    disconnectRedux();
  };
  this.shouldShowNoResultsError = function () {
    return (_this.state.customerSearchResultCount === 0 || _this.state.giftCardSearchResultCount === 0 || _this.state.couponSearchResultCount < 0) && _this.canShowNoResultsError && !_this.hasFormErrors() && _this.state.apiErrors.length === 0 && _this.searchExecuted && !_this.state.isFetchingResults;
  };
  this.getErrorLookupObject = function () {
    return {
      emptyTransacationFormFields: {
        required: i18n.translate(_this.customerCareLocaleKeys.SEARCH_ERRORS_CUSTOMER.EMPTY_FORM_ERROR)
      },
      additionalSearchCriteria: {
        required: i18n.translate(_this.customerCareLocaleKeys.SEARCH_ERRORS_CUSTOMER.ADDITIONAL_SEARCH_CRITERIA_ERROR)
      },
      caseId: {
        pattern: i18n.translate(_this.customerCareLocaleKeys.SEARCH_ERRORS_CUSTOMER.CASEID_FORMAT_ERROR)
      },
      caseExternalReference: {
        required: i18n.translate(_this.customerCareLocaleKeys.SEARCH_ERRORS_CUSTOMER.CASE_EXTERNAL_REFERENCE_INCOMPLETE_ERROR)
      },
      customerSearchForm: {
        required: i18n.translate(_this.customerCareLocaleKeys.SEARCH_ERRORS_CUSTOMER.EMPTY_FORM_ERROR)
      },
      email: {
        pattern: i18n.translate(_this.customerCareLocaleKeys.SEARCH_ERRORS_CUSTOMER.EMAIL_FORMAT_ERROR),
        regex: i18n.translate(_this.customerCareLocaleKeys.SEARCH_ERRORS_CUSTOMER.EMAIL_FORMAT_ERROR)
      },
      filterPaymentInstrumentType: {
        required: i18n.translate(_this.customerCareLocaleKeys.SEARCH_ERRORS_CUSTOMER.PAYMENT_TYPE_ERROR)
      },
      firstName: {
        required: i18n.translate(_this.customerCareLocaleKeys.SEARCH_ERRORS_CUSTOMER.INVALID_NAME_ERROR)
      },
      giftCardAccountNumber: {
        pattern: i18n.translate(_this.customerCareLocaleKeys.SEARCH_ERRORS_GIFT_CARD.ACCOUNT_NUMBER_ERROR),
        minlength: i18n.translate(_this.customerCareLocaleKeys.SEARCH_ERRORS_GIFT_CARD.ACCOUNT_NUMBER_LENGTH_ERROR)
      },
      lastName: {
        required: i18n.translate(_this.customerCareLocaleKeys.SEARCH_ERRORS_CUSTOMER.INVALID_NAME_ERROR)
      },
      orderId: {
        pattern: i18n.translate(_this.customerCareLocaleKeys.SEARCH_ERRORS_CUSTOMER.ORDERID_FORMAT_ERROR)
      },
      postalCode: {
        required: i18n.translate(_this.customerCareLocaleKeys.SEARCH_ERRORS_CUSTOMER.EMPTY_POSTAL_CODE_ERROR)
      },
      senderEmailAddress: {
        pattern: i18n.translate(_this.customerCareLocaleKeys.SEARCH_ERRORS_GIFT_CARD.EMAIL_FORMAT_ERROR)
      },
      serviceId: {
        pattern: i18n.translate(_this.customerCareLocaleKeys.SEARCH_ERRORS_CUSTOMER.SERVICEID_FORMAT_ERROR)
      },
      subscriberId: {
        pattern: i18n.translate(_this.customerCareLocaleKeys.SEARCH_ERRORS_CUSTOMER.SUBSCRIBERID_FORMAT_ERROR)
      }
    };
  };
  this.requireAccountPaymentReferenceId = function () {
    return (_this.customerFormSearchModel.filterPaymentInstrumentType === SEARCH_PAYMENT_INSTRUMENT_TYPES.CREDIT_CARD || !!_this.customerFormSearchModel.filterPaymentInstrumentType) && !(_this.customerFormSearchModel.filterPaymentInstrumentType === SEARCH_PAYMENT_INSTRUMENT_TYPES.POINT_FOR_SALE) && !_this.customerFormSearchModel.paymentReferenceId && !_this.customerFormSearchModel.paymentReconciliationId && !_this.customerFormSearchModel.paymentAccount && !_this.customerFormSearchModel.paymentFirstFourDigits && !_this.customerFormSearchModel.paymentLastFourDigits && !_this.customerFormSearchModel.purchaseReceiptReference;
  };
  this.requireOneTransactionSearchField = function () {
    return _this.customerFormSearchModel.paymentTransactionDate !== undefined && !_this.customerFormSearchModel.filterPaymentInstrumentType && !_this.customerFormSearchModel.paymentReferenceId && !_this.customerFormSearchModel.paymentAccount && !_this.customerFormSearchModel.paymentFirstFourDigits && !_this.customerFormSearchModel.paymentLastFourDigits && !_this.customerFormSearchModel.purchaseReceiptReference;
  };
  this.checkForErrors = function (ngFormError) {
    var errorModelList = formHasErrors(ngFormError, _this.errorLookup);

    // Transaction search validations
    if (_this.state.searchType === SEARCH_DROPDOWN_CONSTANTS.TRANSACTION) {
      // If payment type is chosen, check to see if
      // payment reference or account number (full or partial) is also set
      if (_this.requireAccountPaymentReferenceId()) {
        errorModelList.push({
          description: _this.errorLookup.emptyTransacationFormFields.required
        });
      }
      if (_this.requireOneTransactionSearchField()) {
        if (errorModelList.length === 0) {
          errorModelList.push({
            description: _this.errorLookup.additionalSearchCriteria.required
          });
        }
      }
    }

    // check to make sure at least one field was provided (also check for zero since it might be a code type)
    // If there was any other form error, don't log this since at least one of the form elements has been set elsewhere
    if (errorModelList.length === 0 && Object.values(_this.customerFormSearchModel).every(function (value) {
      return !value && value !== 0 || value && value.length === 0 || value === SEARCH_PAYMENT_INSTRUMENT_TYPES.POINT_FOR_SALE;
    })) {
      errorModelList.push({
        description: _this.errorLookup.customerSearchForm.required
      });
    }
    if (_this.state.isDbss && _this.customerFormSearchModel.subscriberIdentification) {
      if (errorModelList.length === 0 && _this.validateSubscriberIdentification()) {
        errorModelList.push({
          description: _this.errorLookup.customerSearchForm.required
        });
      }
    }

    // Case external reference validation
    if (_this.customerFormSearchModel.caseExternalReference) {
      if (_this.validateCaseExternalReference()) {
        errorModelList.push({
          description: _this.errorLookup.caseExternalReference.required
        });
      }
    }
    _this.formErrors = errorModelList;
    return errorModelList.length > 0;
  };
  this.validateSubscriberIdentification = function () {
    return _this.customerFormSearchModel.subscriberIdentification ? !_this.customerFormSearchModel.subscriberIdentification.Value && _this.customerFormSearchModel.subscriberIdentification.Type || _this.customerFormSearchModel.subscriberIdentification.Value && !_this.customerFormSearchModel.subscriberIdentification.Type : false;
  };
  this.validateCaseExternalReference = function () {
    return _this.customerFormSearchModel.caseExternalReference ? !_this.customerFormSearchModel.caseExternalReference.Value && _this.customerFormSearchModel.caseExternalReference.Type || _this.customerFormSearchModel.caseExternalReference.Value && !_this.customerFormSearchModel.caseExternalReference.Type : false;
  };
  this.checkIfSubscriberIdentificationPresent = function () {
    return _this.customerFormSearchModel.subscriberIdentification ? _this.customerFormSearchModel.subscriberIdentification.Value && _this.customerFormSearchModel.subscriberIdentification.Type : false;
  };
  this.checkIfCaseExternalReferencePresent = function () {
    return _this.customerFormSearchModel.caseExternalReference ? _this.customerFormSearchModel.caseExternalReference.Value && _this.customerFormSearchModel.caseExternalReference.Type : false;
  };
  this.shouldShowSearchSelectBox = function () {
    return _this.state.searchType !== SEARCH_DROPDOWN_CONSTANTS.GIFT_CARD && _this.state.searchType !== SEARCH_DROPDOWN_CONSTANTS.COUPON;
  };
  this.shouldShowSearchError = function () {
    return !_this.hasFormErrors() && _this.state.apiErrors.length > 0;
  };
  this.searchTypeChanged = function (item) {
    _this.searchExecuted = false;
    _this.clearAllErrors();
    _this.setSelectedOption(item.id);
  };
  this.clearFormErrors = function () {
    _this.formErrors = [];
  };
  this.clearAllErrors = function () {
    _this.getAccountNumberFieldTitle();
    if (_this.actions) {
      _this.actions.clearSearchError();
      _this.clearFormErrors();
    }
  };
  this.hasFormErrors = function () {
    return _this.formErrors && _this.formErrors.length > 0;
  };
  this.getSearchTypeKey = function () {
    if (_this.state.searchType === SEARCH_DROPDOWN_CONSTANTS.GIFT_CARD) {
      return _this.customerCareLocaleKeys.GIFT_CARD;
    } else if (_this.state.searchType === SEARCH_DROPDOWN_CONSTANTS.COUPON) {
      return _this.customerCareLocaleKeys.COUPON;
    } else {
      return _this.customerCareLocaleKeys.CUSTOMER;
    }
  };
  this.fetchSubscriberSuggestions = function (queryStr) {
    return _this.actions.searchSubscriberSuggestions(queryStr, _this.state.searchType).then(function () {
      _this.customerFormSearchModel.emailOrLoginSuggestions = _this.state.customerSearchSuggestions;
      return _this.state.customerSearchSuggestions;
    });
  };
  this.onSuggestionSelected = function () {
    $element.find('#customerSearchForm .c-searchPanel-footer .c-button--primary').trigger('click');
  };
  this.onCustomerSearchIdetifificaticonTypeSelect = function (selectedIdentificationType) {
    if (!_this.customerFormSearchModel.subscriberIdentification) {
      _this.customerFormSearchModel.subscriberIdentification = {};
    }
    if (selectedIdentificationType.id) {
      _this.customerFormSearchModel.subscriberIdentification.Type = selectedIdentificationType.id;
    } else {
      delete _this.customerFormSearchModel.subscriberIdentification;
    }
  };
  this.onCustomerSearchIdentificationValue = function () {
    if (!_this.customerFormSearchModel.subscriberIdentification) {
      _this.customerFormSearchModel.subscriberIdentification = {
        Type: null
      };
    }
    if (_this.selectedIdentificationEntity) {
      _this.customerFormSearchModel.subscriberIdentification.Value = _this.selectedIdentificationEntity;
    } else {
      delete _this.customerFormSearchModel.subscriberIdentification;
    }
  };
  this.onCaseExternalReferenceTypeSelect = function (selectedCaseExtRefType) {
    if (!_this.customerFormSearchModel.caseExternalReference) {
      _this.customerFormSearchModel.caseExternalReference = {};
    }
    if (selectedCaseExtRefType.id) {
      _this.customerFormSearchModel.caseExternalReference.Type = selectedCaseExtRefType.id;
    } else {
      delete _this.customerFormSearchModel.caseExternalReference;
    }
  };
  this.onCaseExternalReferenceValue = function () {
    if (!_this.customerFormSearchModel.caseExternalReference) {
      _this.customerFormSearchModel.caseExternalReference = {
        Type: null
      };
    }
    if (_this.selectedCaseExternalReferenceEntity) {
      _this.customerFormSearchModel.caseExternalReference.Value = _this.selectedCaseExternalReferenceEntity;
    } else {
      delete _this.customerFormSearchModel.caseExternalReference;
    }
  };
  this.onAdditionalPropertyChange = function (id, newValue) {
    var currentProperty = _this.customerFormSearchModel.subscriberAdditionalProperties && _this.customerFormSearchModel.subscriberAdditionalProperties.length ? _this.customerFormSearchModel.subscriberAdditionalProperties.filter(function (prop) {
      return prop.Code === id;
    }) : [];
    var currentAdditionalProperty = _this.state.subscriberAdditionalPropData.find(function (prop) {
      return prop.id === id;
    });
    var value = newValue;
    if (currentAdditionalProperty.type === AdditionalPropertyValueType.BOOLEAN || currentAdditionalProperty.type === AdditionalPropertyValueType.SELECT) {
      value = currentAdditionalProperty.options.find(function (option) {
        return option.id === newValue;
      }).name;
    }
    if (!currentProperty.length) {
      _this.customerFormSearchModel.subscriberAdditionalProperties.push({
        Code: id,
        Value: value.toString()
      });
    } else {
      _this.customerFormSearchModel.subscriberAdditionalProperties.map(function (property) {
        if (property.Code !== id) {
          return property;
        } else {
          return Object.assign(property, {
            Value: value.toString()
          });
        }
      });
    }
    _this.actions.setEditApOnChange(id, newValue);
  };
}

// Definition for the self-contained SearchFields component
export var SearchFields = {
  template: require('./search.fields.html'),
  controller: SearchFieldsController,
  controllerAs: 'SearchFields',
  bindings: {
    customerSearchModel: '<',
    pageNumber: '<',
    onPageChange: '&',
    onCustomerSearchModelChange: '&',
    searchFieldsApi: '&?'
  }
};